// Helpers ported from dashboard.html — small, focused, no DOM side effects.

export function makeHref(url: string | null | undefined): string {
  if (!url) return '';
  const trimmed = url.trim();
  if (!trimmed) return '';
  if (/^https?:\/\//i.test(trimmed)) return trimmed;
  return `https://${trimmed}`;
}

export function displayUrl(url: string | null | undefined): string {
  if (!url) return '';
  return url.replace(/^https?:\/\//i, '').replace(/^www\./i, '').replace(/\/+$/, '');
}

export function splitEmails(emails: string | null | undefined): string[] {
  if (!emails) return [];
  return emails
    .split(/[,;\s]+/)
    .map((e) => e.trim())
    .filter(Boolean);
}

export function renderStars(rating: number, max = 5): string {
  const r = Math.max(0, Math.min(max, Math.round(rating)));
  return '★'.repeat(r) + '☆'.repeat(max - r);
}

export function formatNumber(num: number): string {
  if (num >= 1_000_000) return (num / 1_000_000).toFixed(1) + 'M';
  if (num >= 1_000) return (num / 1_000).toFixed(1) + 'K';
  return String(num);
}

export function formatPercent(val: number | null | undefined): string {
  if (val === null || val === undefined || Number.isNaN(val)) return '—';
  const sign = val >= 0 ? '+' : '';
  return `${sign}${val.toFixed(1)}%`;
}

export function formatDuration(seconds: number | null | undefined): string {
  const s = Math.max(0, Math.round(Number(seconds) || 0));
  const m = Math.floor(s / 60);
  const r = s % 60;
  return `${m}:${r < 10 ? '0' : ''}${r}`;
}

export function pctChange(current: number, previous: number): number {
  if (previous === 0) return current > 0 ? 100 : 0;
  return Math.round(((current - previous) / previous) * 1000) / 10;
}

// ISO-week-string from GA4 (YYYYWW like "202614") → readable "M/D" label
// (start-of-week date). Verbatim port from Flask dashboard.html.
export function isoWeekStartLabel(weekStr: string): string {
  if (!weekStr || weekStr.length !== 6) return weekStr;
  const yr = parseInt(weekStr.substring(0, 4), 10);
  const wk = parseInt(weekStr.substring(4), 10);
  if (Number.isNaN(yr) || Number.isNaN(wk)) return weekStr;
  const jan4 = new Date(yr, 0, 4);
  const dayOfWeek = jan4.getDay() || 7;
  const weekStart = new Date(jan4);
  weekStart.setDate(jan4.getDate() - dayOfWeek + 1 + (wk - 1) * 7);
  return `${weekStart.getMonth() + 1}/${weekStart.getDate()}`;
}
